import { fontProperties, magnifiers } from "../consts/fontSize";
import { createContext, useContext, useEffect, useState } from "react";

export const ThemeContext = createContext({
  magnifiers: magnifiers(),
  activeMagnifier: magnifiers()[0],
  setActiveMagnifier: (value: any) => {},
  magnifyText: (number: number) => {},
});

export const ThemeProvider = ({ children }: { children: any }) => {
  const savedTheme = localStorage.getItem('fontSize');
  const defaultMagnifierValue = !!savedTheme
    ? JSON.parse(savedTheme)
    : magnifiers()[0];
  const [activeMagnifier, setActiveMagnifier] = useState(defaultMagnifierValue);
  const magnifyText = (number: number) => number * activeMagnifier?.value!;

  useEffect(() => {
    fontProperties.forEach(({ label, value, unit }) =>
      document.documentElement.style.setProperty(
        label,
        `${magnifyText(value)}${unit}`
      )
    );
  }, [activeMagnifier]);

  const updateMagnifier = (fontSize: any) => {
    const activeMagnifier = magnifiers()?.find((magnifier) => magnifier?.label === fontSize?.label)
    setActiveMagnifier(activeMagnifier);
    localStorage.setItem('fontSize', JSON.stringify(activeMagnifier));
  };

  return (
    <ThemeContext.Provider
      value={{
        magnifiers: magnifiers(),
        activeMagnifier: activeMagnifier!,
        setActiveMagnifier: updateMagnifier,
        magnifyText,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};